/**
 * Utility: Constructs the shipping address string from the shipping form inputs.
 * @returns {String} The complete shipping address.
 */
function getShippingAddress() {
  const firstName = document.getElementById("shipto-first_name").value || "";
  const lastName  = document.getElementById("shipto-last_name").value || "";
  const address1  = document.getElementById("shipto-address1").value || "";
  const address2  = document.getElementById("shipto-address2") ? document.getElementById("shipto-address2").value : "";
  const city      = document.getElementById("shipto-city").value || "";
  const province  = document.getElementById("shipto-province").value || "";
  const zip       = document.getElementById("shipto-zip").value || "";
  const country   = document.getElementById("country").value || "";
  const phone     = document.getElementById("shipto-phone").value || "";
  
  const fullName = firstName + " " + lastName;
  let addressString = fullName + "\n" + address1;
  if (address2) {
    addressString += "\n" + address2;
  }
  addressString += "\n" + city + ", " + province + " " + zip + "\n" + country;
  if (phone) {
    addressString += "\nPhone: " + phone;
  }
  console.log("[getShippingAddress] Address built:\n", addressString);
  return addressString;
}

/**
 * Utility: Determines shipping option for each logmat group based on data attributes.
 * If both data-free-shipping-eligible and data-free-shipping are "true", then it returns "free shipping".
 * Otherwise, it returns "batch shipping".
 * @returns {Object} An attributes object with keys for each logmat group.
 */
function getShippingOptionsAttributes() {
  const shippingAttributes = {};
  const groups = document.querySelectorAll(".logmat-group");

  // Organize groups by logmat ID.
  const groupsByLogmat = {};
  groups.forEach(group => {
    const logmatId = group.getAttribute("data-logmat");
    if (!logmatId) return;
    if (!groupsByLogmat[logmatId]) groupsByLogmat[logmatId] = [];
    groupsByLogmat[logmatId].push(group);
  });

  // Determine the shipping option per logmat.
  Object.keys(groupsByLogmat).forEach(logmatId => {
    // Consider free shipping if at least one instance is eligible and confirmed.
    const freeShippingAvailable = groupsByLogmat[logmatId].some(group => {
      return group.getAttribute("data-free-shipping-eligible") === "true" &&
             group.getAttribute("data-free-shipping") === "true";
    });
    shippingAttributes[`shipping_option_logmat_${logmatId}`] =
      freeShippingAvailable ? "free shipping" : "batch shipping";
  });

  return shippingAttributes;
}

/**
 * Utility: Updates cart attributes by POSTing to /cart/update.js.
 * @param {Object} attributes - Key/value pairs to be added as cart attributes.
 * @returns {Promise} Resolves when the update is complete.
 */
function updateCartAttributes(attributes) {
  const formData = new FormData();
  for (const key in attributes) {
    formData.append(`attributes[${key}]`, attributes[key]);
  }
  return fetch('/cart/update.js', {
    method: 'POST',
    body: formData
  })
    .then(response => response.json())
    .catch(error => {
      throw error;
    });
}

/**
 * Handler for the #cart-checkout-btn button.
 * Gathers the shipping options (using data attributes on the logmat groups)
 * and the shipping address, updates the cart attributes, and then redirects to /checkout.
 */
function handleCartCheckoutClick(e) {
  e.preventDefault();
  
  let shippingAttributes = getShippingOptionsAttributes();
  shippingAttributes["shipping address"] = getShippingAddress();
  
  updateCartAttributes(shippingAttributes)
    .then(() => {
      window.location.href = "/checkout";
    })
    .catch(error => {
      console.error("[Cart Checkout] Error updating cart attributes:", error);
    });
}

/**
 * Attach event listener for the checkout button once DOM is ready.
 */
document.addEventListener("DOMContentLoaded", function() {
  const checkoutBtn = document.getElementById("cart-checkout-btn-2");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", handleCartCheckoutClick);
  }
});